module.exports = __webpack_public_path__ + "img/4.433eb73f.png";